import { FC } from 'react';
import { Info } from 'lucide-react';
import { Can } from '@new/casl';

export const DegreeInfoBanner: FC = () => {
  return (
    <Can I="enroll" a="Degree">
      <div className="flex p-5 items-center gap-3 rounded-xl bg-(--warning-W200)">
        <Info size={20} className="text-(--primary-O900) shrink-0" />
        <p className="[font-size:var(--fs-p4)]! text-(--primary-O1100)! font-medium m-0!">
          Enroll in courses to start your learning journey. Track your progress and complete
          objectives to earn credits.
        </p>
      </div>
    </Can>
  );
};
